// src/menu-items/sms.jsx
const Sms = {
  id: "group-sms",
  title: "SMS",
  type: "group",
  children: [
    {
      id: "sms-list",
      title: "SMS List",
      type: "item",
      url: "/sms",
      icon: "ph ph-message-text"
    }
  ]
};

export default Sms;
